module.exports = __webpack_public_path__ + "img/blank-profile-picture.98af95ff.png";